import * as constants from './constants'
import api from '../../api'

const URL_BASE = 'users'
const URL_BASE_ATTRS = 'user-attrs'

export const getAttrs = () => {
  let request = '/'+URL_BASE_ATTRS
  return api.makeBasicRequest( request );
}

export const getRecords = ( query, action ) => {
  let request = '/'+URL_BASE
  if ( query )
    request += '?'+query.join('&');
  return api.makeRequest( request, constants.RECORDS_LOAD );
}

export const getRecord = ( recordId, action=null ) => {
  let request = '/'+URL_BASE+'/'+recordId;
  if ( action )
    return api.makeRequest( request, action );
  return api.makeBasicRequest( request );
}

export const updateRecord = record => {
  console.log( "Updating "+constants.LABEL, record );
  if ( record[constants.ID_FIELD] )
    return api.makeRequest({
      method: 'put',
      url: '/'+URL_BASE+'/'+record[constants.ID_FIELD],
      data: {
        record
      }},
      constants.RECORD_UPDATE
    )
  return api.makeRequest({
    method: 'post',
    url: '/'+URL_BASE,
    data: {
      record
    }},
    constants.RECORD_UPDATE
  )
}

export const deleteRecord = record => {
  console.log( "Deleting "+constants.LABEL, record )
  return api.makeRequest({
      method: 'delete',
      url: '/'+URL_BASE+'/'+record[constants.ID_FIELD]
    },
    constants.RECORD_DELETE,
  );
}

export const searchRecords = ( search, limit=null ) => {
  let request = '/'+URL_BASE
  let params = []
  if ( search )
    params.push( 'search.employee_name='+search )
  if ( limit )
    params.push( 'page.num=1&page.size='+limit )
  if ( params.length )
    request += '?'+params.join('&');
  return api.makeBasicRequest( request )
}
